(function (ng) {
    ng.module('evo.Compare.Directives').directive('productImage', ['PRODUCT_IMAGE_ROOT',
        function (PRODUCT_IMAGE_ROOT) {
            return {
                link: function ($scope) {
                    $scope.buildImagePath = function () {
                        var relativePath = $scope.image && $scope.image.RelativePath ? $scope.image.RelativePath : '_notavailable.jpg';
                        return PRODUCT_IMAGE_ROOT + relativePath;
                    };

                    $scope.updateProductImage = function () {
                        if (!$scope.product) {
                            return;
                        }
                        $scope.product.Image = $scope.image;
                    };
                },
                replace: true,
                restrict: 'E',
                scope: {
                    alt: '@',
                    image: '=',
                    product: '=',
                    title: '@'
                },
                template: '<img alt="{{ alt }}" product-image-load ng-click="updateProductImage()" ng-src="{{ buildImagePath() }}" title="{{ title }}" />'
            };
        }
    ]);
})(angular);